import React from 'react'
import { without } from 'lodash'
import { FlexColumn, Text } from 'elements'
import { useAnalytics } from 'hooks'
import ReportSectionRow from './ReportSectionRow'

export default function SelectReportSections({
  defaultReportSections,
  defaultTemplate,
  configSections,
  setConfigSections,
}) {
  const analytics = useAnalytics()

  const handleCheck = (section) => {
    const checkSection = configSections.find((configSection) => configSection.name === section.name)

    if (checkSection) {
      setConfigSections(without(configSections, checkSection))

      analytics.track('Template Section Removed', { sectionName: section.name })
    } else {
      setConfigSections([
        ...configSections,
        //add the section back in with the default config
        defaultTemplate.config.sections.find(
          (defaultTemplateSection) => defaultTemplateSection.name === section.name,
        ),
      ])

      analytics.track('Template Section Added', { sectionName: section.name })
    }
  }

  const { anomalies, financialReports, metadata } = defaultReportSections

  return (
    <FlexColumn>
      <FlexColumn mb="xlarge">
        <Text fontWeight="bold" mb="medium">
          Anomalies
        </Text>
        {anomalies.map((reportSection, idx) => (
          <ReportSectionRow
            key={[reportSection.name, reportSection.type]}
            reportSection={reportSection}
            configSections={configSections}
            setConfigSections={setConfigSections}
            handleCheck={handleCheck}
            mb={idx !== anomalies.length - 1 ? 'small' : null}
          />
        ))}
      </FlexColumn>
      <FlexColumn mb="xlarge">
        <Text fontWeight="bold" mb="medium">
          Financial Reports
        </Text>
        {financialReports.map((reportSection, idx) => (
          <ReportSectionRow
            key={[reportSection.name, reportSection.type]}
            reportSection={reportSection}
            configSections={configSections}
            setConfigSections={setConfigSections}
            handleCheck={handleCheck}
            mb={idx !== financialReports.length - 1 ? 'small' : null}
          />
        ))}
      </FlexColumn>
      <FlexColumn>
        <Text fontWeight="bold" mb="medium">
          Other
        </Text>
        {metadata.map((reportSection, idx) => (
          <ReportSectionRow
            key={[reportSection.name, reportSection.type]}
            reportSection={reportSection}
            configSections={configSections}
            setConfigSections={setConfigSections}
            handleCheck={handleCheck}
            mb={idx !== metadata.length - 1 ? 'small' : null}
          />
        ))}
      </FlexColumn>
    </FlexColumn>
  )
}
